import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils.mjs';

function SvgIcSubwayFill(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.25 5.5A.75.75 0 0 1 9 4.75h6a.75.75 0 0 1 0 1.5H9a.75.75 0 0 1-.75-.75"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4 5a2.75 2.75 0 0 1 2.75-2.75h10.5A2.75 2.75 0 0 1 20 5v11.594a2.75 2.75 0 0 1-2.49 2.738l1.77 1.77a.75.75 0 1 1-1.06 1.061l-.593-.593H6.373l-.593.593a.75.75 0 0 1-1.06-1.06l1.77-1.771A2.75 2.75 0 0 1 4 16.594zm4.47 14.344h7.06a.75.75 0 0 0 .19.32l.407.406H7.873l.407-.407a.75.75 0 0 0 .19-.32M6.75 3.75c-.69 0-1.25.56-1.25 1.25v6.25h13V5c0-.69-.56-1.25-1.25-1.25zm1.5 12.867a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5m7.5 0a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5",
    clipRule: "evenodd"
  }));
}
var IcSubwayFill = createNolIcon(/*#__PURE__*/forwardRef(SvgIcSubwayFill));

export { IcSubwayFill as I };
